import {
    BodyLargeRegular,
    Button,
    ButtonSize,
    ButtonVariant,
    Sheet,
    YStack,
} from 'smoothie';

interface ConfirmIncomeDeleteSheetProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

const ConfirmIncomeDeleteSheet = ({
    isOpen,
    onClose,
    onConfirm,
}: ConfirmIncomeDeleteSheetProps) => {
    return (
        <Sheet isOpen={isOpen} onClose={onClose} showCloseButton={false}>
            <BodyLargeRegular>
                Are you sure you want to remove this income?
            </BodyLargeRegular>
            <YStack marginTop={12} gap={8}>
                <Button
                    variant={ButtonVariant.PRIMARY}
                    size={ButtonSize.LARGE}
                    tone="danger"
                    text="Yes, remove this income"
                    onPress={() => {
                        onConfirm();
                        onClose();
                    }}
                />
                <Button
                    variant={ButtonVariant.SECONDARY}
                    size={ButtonSize.LARGE}
                    text="Cancel"
                    onPress={() => {
                        onClose();
                    }}
                />
            </YStack>
        </Sheet>
    );
};

export default ConfirmIncomeDeleteSheet;
